import { render, staticRenderFns } from "./ProductCardItem.vue?vue&type=template&id=98261c56&scoped=true&"
import script from "./ProductCardItem.vue?vue&type=script&lang=js&"
export * from "./ProductCardItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardItem.vue?vue&type=style&index=0&id=98261c56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98261c56",
  null
  
)

export default component.exports